<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-asterisk icon-button"
                title="Atualizar Dotação Padrão"
                @click.stop="confirmarAtualizarDotacaoPadrao()"
            ></i>
        </span>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        dotacao: {
            type: Object,
            default: () => ({})
        },

    },

    data() {
        return {
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        confirmarAtualizarDotacaoPadrao() {
            // if (!this.contratoElaboracao() && !this.aditivarContrato()) {
            //     if (this.contratoApostilamento == null) {
            //         this.$swal({
            //             title: 'O que deseja fazer ?',
            //             icon: 'warning',
            //             showCancelButton: true,
            //             confirmButtonColor: '#3085d6',
            //             cancelButtonColor: '#d33',
            //             confirmButtonText: 'Apostilar',
            //             cancelButtonText: 'Atualizar'
            //         }).then((result) => {
            //             if (result.value) {
            //                 this.alternaJustificativa(
            //                     result.value == true ? 1 : 0
            //                 )
            //                 this.mostrarAlerta()
            //             } else if (result.isDismissed) {
            //                 this.alternaJustificativa(
            //                     result.isConfirmed == true ? 1 : 0
            //                 )
            //                 this.mostrarAlerta()
            //             }
            //         })
            //     } else if (this.contratoApostilamento == 1) {
            //         this.alternaJustificativa(this.contratoApostilamento)
            //         this.mostrarAlerta()
            //     } else if (this.contratoApostilamento == 0) {
            //         this.alternaJustificativa(this.contratoApostilamento)
            //         this.mostrarAlerta()
            //     }
            // } else {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Confirma a atualização da dotação padrao <br/><b>${this.dotacao.codCCusto}<br/>${this.dotacao.nomeCCusto}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.atualizarDotacaoPadrao()
                }
            })
            // }
        },

        // mostrarAlerta() {
        //     this.$swal({
        //         title: 'Dotação Orçamentária',
        //         html: `Confirma a exclusão da dotação orçamentária<br/><b>${this.dotacao.codCCusto}<br/>${this.dotacao.nomeCCusto}?`,
        //         icon: 'warning',
        //         showCancelButton: true,
        //         confirmButtonColor: '#3085d6',
        //         cancelButtonColor: '#d33',
        //         confirmButtonText: 'Sim',
        //         cancelButtonText: 'Não',
        //         input: 'textarea',
        //         inputPlaceholder: `Informe a ${this.labelJustificativa}`,
        //         inputValidator: (value) => {
        //             if (!value) {
        //                 return `A justificativa ${this.textoInfoJustificativa} é obrigatória'`
        //             }
        //         }
        //     }).then((result) => {
        //         if (result.value) {
        //             this.excluirDotacao(result.value)
        //         }
        //     })
        // },

        atualizarDotacaoPadrao(justificativa) {
            this.$store.dispatch('addRequest')
            let dotacaoDto = {
                idRateioComprometimento: this.dotacao.idRateioComprometimento,
                idContrato: this.$route.params.contratoId,
                // justificativaApostilamento: justificativa,
                // isApostilamento: this.contratoApostilamento
            }
            ContratosServicos.atualizarDotacaoPadrao(dotacaoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterDotacoesAtualizadas')
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'justificativa do apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = 'a justificativa'
            }
        },

        alternaJustificativaPorAcesso() {
            if (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.$temAcessoView('CONT-APOST-02')
            ) {
                this.contratoApostilamento = null
            } else if (this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if (this.$temAcessoView('CONT-APOST-02')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
    }
}
</script>

<style>

</style>